import hooks from './shipment-offers.hooks';
import createSchema from './shipment-offers.schema';

export default (app) => {
  const service = app.service('api/shipment-offers');

  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };

  service.schema = createSchema(app);
  service.hooks(hooks);
};
